import 'core-js/stable'
import 'regenerator-runtime/runtime' // react-form uses async functions.

import '../lib/ReactOnRails' // Ensure ReactOnRails has our API extensions.
import ReactOnRails from 'react-on-rails'

import { PrayerForm, PrayerList } from '../bundles/Prayers'

ReactOnRails.register({ PrayerForm, PrayerList })
